import { GlobalState } from '@leverege/ui-redux';
import { Context } from '@leverege/plugin';
import { DataSources } from '@leverege/ui-attributes';
import { Dialogs } from '@leverege/ui-elements';
import EnableDialog from '../../dashboard/viewer/theftRecovery/views/EnableDialog';
import DisableDialog from '../../dashboard/viewer/theftRecovery/views/DisableDialog';
import Util from '../../views/salesFlow/Util';
export default {
  id: 'recovr.action.TheftRecovery',
  name: 'Theft Recovery',
  layout: {
    sort: 'security.theftRecovery',
    sectionName: 'Security'
  },
  matches: [{
    client: ['GroupScreen', 'ItemInfoScreen'],
    use: ['contextMenu', 'mobileActionBar'],
    objectType: 'vehicle'
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: 'contextMenu'
  }],
  prepare: async cxt => {
    const {
      clientState,
      clientProps
    } = cxt;
    const delegate = clientProps?.delegate || clientState?.actionsContext?.clientProps?.delegate;
    if (delegate.relationship.isItem) {
      return GlobalState.dispatch(delegate.parent().requestCanCreate());
    }
    return GlobalState.dispatch(delegate.requestCanCreate());
  },
  isPrepared: cxt => {
    const {
      clientState,
      clientProps
    } = cxt;
    const delegate = clientProps?.delegate || clientState?.actionsContext?.clientProps?.delegate;
    if (delegate.relationship.isItem) {
      return delegate.parent().canCreate(undefined, undefined, undefined, false) != null;
    }
    return delegate.canCreate(undefined, undefined, undefined, false) != null;
  },
  handles: cxt => {
    const {
      clientState,
      clientProps
    } = cxt;
    const delegate = clientProps?.delegate || clientState?.actionsContext?.clientProps?.delegate;
    let can;
    if (delegate.relationship.isItem) {
      can = delegate.parent().canCreate();
    } else {
      can = delegate.canCreate();
    }
    if (can !== true) {
      return false;
    }
    const targets = Context.getTargetsOfType(cxt, 'vehicle');
    return targets && targets.length === 1 && targets[0]?.data?.data?.locator?.id && Util.isLocatorActivated(targets[0]?.data?.data?.locator);
  },
  appearance: props => {
    const context = props?.context?.clientState?.actionsContext || props.context;
    const item = Context.getTarget(context);
    const stolen = item?.data?.data?.locator?.data?.businessState === 'stolen';
    return {
      name: stolen ? 'End Theft Recovery' : 'Activate Theft Recovery',
      icon: 'https://recovr-ui-assets.storage.googleapis.com/icon-theft-recovery.png',
      imageOpts: {
        style: {
          width: '20px',
          height: '20px'
        }
      }
    };
  },
  perform: props => {
    const context = props?.context?.clientState?.actionsContext || props.context;
    const {
      clientProps,
      target
    } = context;
    const item = Context.getTarget(context);
    let [actions] = DataSources.getActions(target);
    if (!actions) {
      actions = clientProps.actions;
    }
    const stolen = item?.data?.data?.locator?.data?.businessState === 'stolen';
    if (stolen) {
      Dialogs.show({
        component: DisableDialog,
        props: {
          caseActions: actions.parent().parent().child('cases').item(item?.data?.case?.id),
          sharedProps: {
            ...clientProps,
            item: item.data,
            actions
          }
        }
      });
    } else {
      Dialogs.show({
        component: EnableDialog,
        props: {
          sharedProps: {
            ...clientProps,
            item: item.data,
            actions
          }
        }
      });
    }
  }
};